import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import { timeline } from "@/mocks/stats";

export default function About() {
  return (
    <section className="px-4 md:px-8 lg:px-12 py-20 md:py-28">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
        <Reveal>
          <div className="flex flex-col gap-6">
            <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-primary-600">
              Quiénes somos
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-900">
              Una trayectoria construida sobre confianza
            </h2>
            <div className="flex flex-col gap-4 text-foreground-600 leading-relaxed">
              <p>
                Inmobiliaria AGI MORSO Ltda. (IAM) cuenta con más de 17 años de experiencia dedicada
                a brindar soluciones habitacionales de vanguardia.
              </p>
              <p>
                A lo largo de nuestra trayectoria hemos desarrollado más de 12 proyectos
                inmobiliarios, involucrando la construcción de 240 casas en condominio,
                principalmente en la comuna de Quinta Normal.
              </p>
              <p>
                Nos hemos destacado por nuestros diseños arquitectónicos innovadores, la seguridad
                de alto nivel en nuestros condominios y la excelencia en la calidad de construcción.
              </p>
              <p>
                En 2023 nace Inmobiliaria ADJ SpA, incorporando nuevos socios y dando inicio a una
                nueva etapa de crecimiento. Esta nueva sociedad permitirá continuar desarrollando
                proyectos en distintas comunas de la Región Metropolitana, manteniendo el mismo
                compromiso con la calidad, la innovación y la excelencia que nos caracteriza.
              </p>
            </div>
            <Link
              to="/nosotros"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              Conoce más de nosotros
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="flex flex-col gap-0">
            {timeline.map((item, index) => (
              <div key={item.value} className="flex gap-5">
                <div className="flex flex-col items-center">
                  <div className="w-10 h-10 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 flex items-center justify-center text-sm font-semibold shrink-0">
                    {index + 1}
                  </div>
                  {index < timeline.length - 1 && (
                    <div className="w-px flex-1 bg-primary-200 my-2" />
                  )}
                </div>
                <div className="pb-10 flex flex-col gap-1">
                  <span className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
                    {item.value}
                  </span>
                  <span className="text-sm text-foreground-500">{item.label}</span>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}